jQuery(document).ready(function ($) {
  initVideoRDTS($);

  function initVideoRDTS() {
    if ($(".videocontainerrdts").length > 0) {
      $(".videocontainerrdts").each(function (index, element) {
        var videourl = "";
        var videotyp = "";
        var videovorschau = "";
        $(this)
          .find(".videoelement")
          .each(function (index, element) {
            videourl = $(element).data("videourl");
            videotyp = $(element).data("videotyp");
            videovorschau = $(element).data("videovorschau");
          });

        var marketingCookie = readCookie("cmplz_marketing");

        if (marketingCookie === "allow") {
          var teilurl = videourl;
          $(".videocookieerror").hide();
          if (videotyp == "youtube") {
            $(this).append(createYoutubeIFrame(teilurl));
          } else if (videotyp == "youtube-shorts") {
            $(this).append(createYouTubeShortFrame(teilurl));
          } else {
            $(this).append("<p>404 Video not found</p>");
          }
        }
      });
    }
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
});

function createYouTubeShortFrame(url) {
  // Example: https://www.youtube.com/shorts/Aq6rDm63ZiE
  var trimmedUrl = url.trim().replace(/\/$/, "");
  var match = trimmedUrl.substring(trimmedUrl.lastIndexOf("/") + 1);
  var returnframe = "<p> Kein Video gefunden </p>";
  if (match && match.length == 11) {
    returnframe =
      '<iframe width="315" height="560" src="https://www.youtube.com/embed/' +
      match +
      '?si=wwkeTuJ_84-Lugd1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
  }
  return returnframe;
}

function createYoutubeIFrame(url) {
  var regExp =
    /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  var match = url.match(regExp);
  var returnframe = "<p> Kein Video gefunden </p>";

  if (match && match[2].length == 11) {
    returnframe =
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
      match[2] +
      '?si=wwkeTuJ_84-Lugd1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
  }

  return returnframe;
}
